import { ActiveAlertsCountSubscription } from "../../graphql/generated/operations";

/**
 * @param {ActiveAlertsCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.alertsAggregate.aggregate?.count;
